import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl, FormGroup } from '@cancercentrum/rcc-bootstrap';
export function AvailableColumnFilters(props) {
    const { filters, value, onChange } = props;
    const options = filters.map((x)=>/*#__PURE__*/ _jsx("option", {
            value: x.type,
            children: x.name
        }, x.type));
    return /*#__PURE__*/ _jsx(FormGroup, {
        children: /*#__PURE__*/ _jsx(FormControl, {
            type: "search",
            bsSize: "sm",
            componentClass: "select",
            onChange: onChange,
            value: value,
            children: options
        })
    });
}
